import { Component, OnInit } from '@angular/core';
import { Input } from '@angular/core';
import { OnChanges } from '@angular/core';
import { SimpleChanges } from '@angular/core';
import { ScreensService } from '../../../theme/screens/screens.service';
import { Output } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { map } from 'rxjs/operators';
import { ViewChild } from '@angular/core';
import { TemplateRef } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-component-list',
    templateUrl: './component-list.component.html',
    styleUrls: ['./component-list.component.scss']
})
export class ComponentListComponent implements OnInit, OnChanges {

    @Input()
    componentId: number;

    @Input()
    parentId: number;

    @Input()
    componentType: string

    items: any[] = [];
    selectedItem: any = null;

    @Output()
    componentIdChange: EventEmitter<any> = new EventEmitter<any>();

    @Output()
    elementSelected: EventEmitter<any> = new EventEmitter<any>();

    @ViewChild('insertComponent')
    private insertComponentRef: TemplateRef<any>;

    constructor(private screensService: ScreensService, private modalService: NgbModal) {
    }

    ngOnInit(): void {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.componentType && changes.componentType.currentValue !== changes.componentType.previousValue) {
            this.fetchComponentByType().subscribe((data) => {
                this.items = data;
                if (this.componentId) {
                    this.selectedItem = this.items.find((el) => el.id === this.componentId);
                }
            })
        }
        if (changes.componentId && changes.componentId.currentValue !== changes.componentId.previousValue) {
            if (this.componentId && this.items.length > 0) {
                this.selectedItem = this.items.find((el) => el.id === this.componentId);
            }
        }
    }

    changeComponentId() {
        this.componentId = this.selectedItem.id;
        this.componentIdChange.emit(this.componentId);
        this.elementSelected.emit(this.selectedItem);
    }

    openInsertModal() {
        let modalRef = this.modalService.open(this.insertComponentRef, {centered: true, size: 'lg'});
        modalRef.result.then((data) => {
        }, (reason) => {
        });
    }

    monumentSaved(event) {
        this.fetchComponentByType().subscribe((data)=>{
            this.items = [...data];
            if (event) {
                this.selectedItem = this.items.find((el) => el.id === event.id);
            }
        });
        this.modalService.dismissAll();
    }

    private fetchComponentByType() {
        if (this.componentType === 'MONUMENT') {
            return this.screensService.getAllMonuments().pipe(
                map((monuments) => {
                    return monuments.map((monument) => {
                        monument["name"] = monument.monumentTranslations[0].name;
                        return monument;
                    })
                })
            )
        } else if (this.componentType === 'SITE') {
            return this.screensService.getSites(true).pipe(
                map((sites) => {
                    return sites.map((site) => {
                        site["name"] = site.siteTranslations[0].name;
                        return site;
                    })
                })
            )
        } else {
            return this.screensService.getAllPanoramaImages().pipe(
                map((panoramaImages) => {
                    return panoramaImages.map((panorama) => {
                        panorama["name"] = "Πανοραμική " + panorama.id;
                        return panorama;
                    })
                })
            );
        }
    }
}
